import { LOGO_URL } from "../data/formOptions";
import { Link } from "react-router-dom";

export default function LogoMark({ size = 36, withText = false, to = "/" }) {
  const content = (
    <span className="inline-flex items-center gap-3 group select-none">
      <span
        className="relative inline-flex items-center justify-center rounded-full overflow-hidden"
        style={{
          width: size,
          height: size,
          boxShadow: "0 0 18px rgba(0, 170, 255,0.35), 0 0 28px rgba(57, 255, 20,0.18)",
        }}
      >
        <img
          src={LOGO_URL}
          alt="CyberSecurity4Charities.org logo"
          className="w-full h-full object-cover"
        />
      </span>
      {withText && (
        <span className="font-mono-tech tracking-tight text-sm">
          <span className="text-white">CyberSecurity</span>
          <span className="text-[#39ff14]">4</span>
          <span className="text-[#00aaff]">Charities</span>
          <span className="text-[#39ff14]">.org</span>
        </span>
      )}
    </span>
  );
  return to ? (
    <Link to={to} data-testid="logo-link" className="group">
      {content}
    </Link>
  ) : (
    content
  );
}
